import {currencyValueDivider} from '@shared/constants';
import {CurrentUser, ImpersonationToken, User, UserBan} from '../types';
import {
  CurrentUserOnBackend,
  ImpersonationTokenOnBackend,
  UserBanOnBackend,
  UserOnBackend,
} from './backendTypes';

export const mapCurrentUserFromBackend = ({
  username,
  name,
  bio,
  avatar,
  email,
  cell_phone,
}: CurrentUserOnBackend): CurrentUser => ({
  username,
  name,
  bio: bio ?? '',
  avatar: avatar ?? '',
  email: email ?? '',
  phone: cell_phone ?? '',
});

export const mapUserBanFromBackend = (data: UserBanOnBackend): UserBan => ({
  userId: data.user_id,
  comment: data.comment,
  bannedBy: data.banned_by,
  bannedByUsername: data.banned_by_username,
  bannedAt: new Date(data.banned_at),
  liftedAt: data.lifted_at ? new Date(data.lifted_at) : null,
  liftedBy: data.lifted_by ?? null,
  liftedByUsername: data.lifted_by_username ?? null,
});

export const mapUserFromBackend = ({
  id,
  username,
  name,
  cell_phone,
  avatar,
  email,
  country,
  is_verified,
  is_admin,
  real_funds,
  promo_funds,
  coins,
  cfp,
  auth_type,
  ban,
  registered_at,
  referrer,
}: UserOnBackend): User => ({
  id,
  username,
  name,
  phone: cell_phone ?? '',
  avatar: avatar ?? '',
  email: email ?? '',
  country: country ?? '',
  isVerified: is_verified ?? false,
  isAdmin: is_admin ?? false,
  fundsReal: (real_funds ?? 0) / currencyValueDivider,
  fundsPromo: (promo_funds ?? 0) / currencyValueDivider,
  coins: coins ?? 0,
  cfp: cfp ?? 0,
  authType: auth_type,
  ban: ban ? mapUserBanFromBackend(ban) : null,
  registeredAt: registered_at ? new Date(registered_at) : null,
  referrer: referrer
    ? {id: referrer.id, username: referrer.username}
    : referrer,
});

export const mapImpersonationTokenFromBackend = ({
  access_token,
  token_type,
  expires_in,
}: ImpersonationTokenOnBackend): ImpersonationToken => ({
  accessToken: access_token,
  tokenType: token_type,
  expiresIn: expires_in,
});
